import React from 'react';
import './ModernToggleSwitch.css';

/**
 * Modern Toggle Switch Component
 * A sleek, modern toggle switch replacement for Bootstrap Form.Check switches
 * 
 * @param {boolean} checked - Whether the toggle is checked
 * @param {function} onChange - Callback when toggle state changes
 * @param {string} id - Unique ID for the toggle
 * @param {boolean} disabled - Whether the toggle is disabled
 * @param {string} className - Additional CSS classes
 * @param {string} variant - Color variant: 'orange' (default), 'green' (for internal), or 'violet'
 */
const ModernToggleSwitch = ({ 
    checked, 
    onChange, 
    id, 
    disabled = false, 
    className = '', 
    variant = 'orange',
    ...props 
}) => {
    const toggleId = id || `modern-toggle-${Math.random().toString(36).substr(2, 9)}`;
    const variantClass = variant === 'green' ? 'modern-toggle-green' : variant === 'violet' ? 'modern-toggle-violet' : 'modern-toggle-orange';
    
    return (
        <label 
            className={`modern-toggle-switch ${variantClass} ${className} ${disabled ? 'disabled' : ''}`}
            htmlFor={toggleId}
        >
            <input
                type="checkbox"
                id={toggleId}
                checked={checked}
                onChange={onChange}
                disabled={disabled}
                {...props}
            />
            <span className="modern-toggle-slider"></span>
        </label>
    );
};

export default ModernToggleSwitch;









